import React from "react";
import PriorityBar from "./PriorityBar";
import BudgetHistogram from "./BudgetHistogram";
import TimelinePatterns from "./TimelinePatterns";
import FinanceMix from "./FinanceMix";
import RichText from "./RichText";
import LegalStrip from "./LegalStrip";

const formatLot = (lotAcres) => {
  if (lotAcres == null) return "—";
  return `${lotAcres} ac`;
};

const MatchPriorities = ({ priorities, property, agent }) => {
  if (!priorities) return null;
  const specs = property.specs || {};
  return (
    <section id="priorities" className="abr-section" aria-labelledby="abr-priorities-title">
      <div className="abr-eyebrow">Match Priorities</div>
      <h2 className="abr-h1" id="abr-priorities-title">
        {priorities.title}
      </h2>
      <p className="abr-lede">
        Preferences, budgets, and timing of buyers actively searching for properties like yours in{" "}
        <span className="abr-accent">{property.zip}</span>.
      </p>

      <div className="abr-subject-row">
        <div>
          <div className="abr-subject-addr">
            {property.addressLine1}
            <span className="abr-your-flag">Your Property</span>
          </div>
          <div className="abr-subject-sub">
            {property.city}, {property.state} {property.zip} &middot; Listed at {property.listedPriceDisplay}
          </div>
        </div>
        <div className="abr-subject-specs">
          <div>
            <div className="abr-subject-spec-label">Beds</div>
            <div className="abr-subject-spec-value">{specs.beds}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Baths</div>
            <div className="abr-subject-spec-value">{specs.baths}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Sq Ft</div>
            <div className="abr-subject-spec-value">{specs.sqft && specs.sqft.toLocaleString()}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Built</div>
            <div className="abr-subject-spec-value">{specs.yearBuilt}</div>
          </div>
          <div>
            <div className="abr-subject-spec-label">Lot</div>
            <div className="abr-subject-spec-value">{formatLot(specs.lotAcres)}</div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 32 }}>
        <div className="abr-card-title">Most-wanted features among buyers matching your property</div>
        <p className="abr-card-sub">
          Nice-to-haves matched buyers flagged on their Want-Listings, ranked by how often each one shows up. These
          are preferences, not hard requirements - they shape match scores but don't disqualify a property. Solid bar
          = your property has it. Outline = property does not.
        </p>
        <PriorityBar items={priorities.ranked || []} />
      </div>

      <div className="abr-two-up">
        <BudgetHistogram budget={priorities.budget} />
        <TimelinePatterns timing={priorities.timing} />
      </div>

      <FinanceMix finance={priorities.finance} />

      <div className="abr-bottom-line">
        <span className="abr-bottom-line-label">Bottom line</span>
        <RichText as="span" className="abr-bottom-line-text" text={priorities.bottomLine} />
      </div>

      <LegalStrip agent={agent} />
    </section>
  );
};

export default MatchPriorities;
